module.exports = __webpack_public_path__ + "img/8group-vr3-icon.830e7641.svg";